import { FC } from "react"
import MoodHigherIcon from "../atoms/MoodHigherIcon"
import MoodHighestIcon from "../atoms/MoodHighestIcon"
import MoodLowerIcon from "../atoms/MoodLowerIcon"
import MoodLowestIcon from "../atoms/MoodLowestIcon"
import MoodNormalIcon from "../atoms/MoodNormalIcon"

interface CustomLabelProps {
  x?: number
  y?: number
  index?: number
}

const MoodGroupIcons: FC<CustomLabelProps> = (tick) => {
  const x = tick?.x ? tick.x - 20 : 0
  const y = tick?.y ? tick.y - 10 : 0
  return (
    <g>
      {tick.index === 0 ? (
        <MoodLowestIcon x={x} y={y} />
      ) : tick.index === 1 ? (
        <MoodLowerIcon x={x} y={y} />
      ) : tick.index === 2 ? (
        <MoodNormalIcon x={x} y={y} />
      ) : tick.index === 3 ? (
        <MoodHigherIcon x={x} y={y} />
      ) : (
        <MoodHighestIcon x={x} y={y} />
      )}
    </g>
  )
}

export default MoodGroupIcons
